import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BioMetricBangla from "../../components/componentsBangla/BioMetricBangla";
import FooterBangla from "../../components/componentsBangla/FooterBangla";
import HeaderOthersBangla from "../../components/componentsBangla/HeaderOthersBangla";
import KonnectBangla from "../../components/componentsBangla/KonnectBangla";
import MerchantTCBangla from "../../components/componentsBangla/MerchnatTCBangla";
import PersonalTCBangla from "../../components/componentsBangla/PersonalTCBangla";
import TransferMoneyBangla from "../../components/componentsBangla/TransferMoneyBangla";
import CCBillPayBangla from "../../components/componentsBangla/CCBillPayBangla";

const useStyle = makeStyles((theme) => ({
  root: {
    margin: "60px 0px",
  },
  title: {
    fontSize: "1.5rem !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
    textAlign: "center",
  },
  content: {
    fontSize: "1rem",
    marginBottom: "20px !important",
  },
  subtitle: {
    fontSize: "1rem",
    marginBottom: "20px !important",
    fontWeight: "500 !important",
  },

  icon: {
    marginRight: 10,
    position: "relative",
    top: 5,
  },
  select: {
    marginBottom: 30,
  },
  footer: {
    marginTop: "-80px",
  },
  center: {
    textAlign: "center",
  },
}));

const TermsConditionBangla = () => {
  const classes = useStyle();
  const location = useLocation();
  let navigate = useNavigate();

  const [doc, setDoc] = useState("");

  const handleChange = (e) => {
    setDoc(e.target.value);
    navigate(`/terms-condition?content=${e.target.value}`);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, -1);
    const search = location.search;
    if (search) {
      const query = new URLSearchParams(search).get("content");
      setDoc(query);
    } else {
      setDoc("personal");
    }

  }, []);

  return (
    <>
      <HeaderOthersBangla title="নিয়ম ও শর্তাবলী" customLink="Terms & Condition" />
      <div className={classes.root}>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item md={12}>
              <div className={classes.select}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Table of Content
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={doc}
                    label="Table of Content"
                    onChange={handleChange}
                  >
                    <MenuItem value="personal">ব্যক্তিগত</MenuItem>
                    <MenuItem value="merchant">মার্চেন্ট</MenuItem>
                    <MenuItem value="biometric">বায়োমেট্রিক প্রমাণীকরণ</MenuItem>
                    {/* <MenuItem value="konnect">কানেক্ট</MenuItem> */}
                    <MenuItem value="credit-card-bill-pay">ক্রেডিট কার্ড বিল পরিশোধ</MenuItem>
                    <MenuItem value="transfer-money">ভিসা ডেবিট কার্ডে ফান্ড ট্রান্সফার</MenuItem>
                  </Select>
                </FormControl>
              </div>

              {doc === "personal" && <PersonalTCBangla />}
              {doc === "merchant" && <MerchantTCBangla />}
              {doc === "biometric" && <BioMetricBangla />}
              {/* {doc === "konnect" && <KonnectBangla />} */}
              {doc === "credit-card-bill-pay" && <CCBillPayBangla />}
              {doc === "transfer-money" && <TransferMoneyBangla />}
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className={classes.footer}>
        <FooterBangla />
      </div>
    </>
  );
};

export default TermsConditionBangla;
